<button
    mat-fab
    color="warn"
    class="language-fab-fixed"
    cdkOverlayOrigin
    #trigger="cdkOverlayOrigin"
    attr.aria-label="{{ 'shared.openLanguageSelection' | translate }}"
    (click)="openLangSelection()">
    <mat-icon fontSet="pi" fontIcon="pi-language" />
</button>
<apcam-language-select
    [languages]="languages"
    [(isOpen)]="langSelectionOpen"
    [trigger]="trigger" />
